export default __webpack_public_path__ + "static/media/eatingtimes_3@2x.554ee50e.jpg";